import React from 'react';
import { styled } from 'dripsy';
import { observer } from 'mobx-react-lite';

import { BaseText } from '../../common/BaseText';
import { ITouchableProps, Touchable } from '../../common/Touchable';
import { Icon } from '../../common/Icon';
import { Separator } from '../../common/Separator';
import type { ColorType } from '@types';

interface ITabButtonStyleProps {
  isActive: boolean;
}

const TouchableContainer = styled(Touchable)(
  (props: ITabButtonStyleProps) => ({
    bg: props.isActive ? '$primary200' : '$background20',
    px: '$5',
    py: '$4',
    borderRadius: 12,
    flexDirection: 'row',
    alignItems: 'center',
  }),
);

interface ITabTextButtonStyleProps {
  isActive: boolean;
}

function activeTextColor(isActive: boolean): ColorType {
  return isActive ? '$heading800' : '$heading500';
}

const Text = styled(BaseText)((props: ITabTextButtonStyleProps) => ({
  color: activeTextColor(props.isActive),
  variant: 'text.large',
}));

export interface IWebHeaderButtonProps
  extends Pick<ITouchableProps, 'onPress' | 'children'> {
  iconName: string;
  isActive: boolean;
}

export const WebHeaderButton = observer<IWebHeaderButtonProps>(
  ({ onPress, isActive, iconName, children }) => {
    return (
      <TouchableContainer onPress={onPress} isActive={isActive}>
        <Icon
          name={iconName}
          size={20}
          color={activeTextColor(isActive)}
        />
        <Separator size="$4" vertical />
        <Text isActive={isActive}>{children}</Text>
      </TouchableContainer>
    );
  },
);
